import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { authAndRegSelector, isAuthenticatedSelector } from "../../redux/profile/authAndReg/selectors";
import { setShowWindow } from "../../redux/profile/authAndReg/slice";
import { rerender } from "../../redux/rerender/slice";
import { useAppDispatch } from "../../redux/store";

import { LoginModal } from "../../components";

import styles from "./LoginIcon.module.scss";

import profileIcon from "../../assets/icons/profile.svg";
import profileIconFocus from "../../assets/icons/profile-focus.svg";

import { WindowNames } from "../../resources/constants";
import { LoginIconPropsType } from "./types";

export const LoginIcon: React.FC<LoginIconPropsType> = ({ isMobileMenu = false }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const auth = useSelector(isAuthenticatedSelector);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClickLogin = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(setShowWindow(WindowNames.AUTH));
    setIsOpen(true);
  };

  const handleClickProfile = () => {
    const currentPath = location.pathname;
    if (
      currentPath === "/profile" ||
      currentPath === "/profile/history" ||
      currentPath === "/profile/cards" ||
      currentPath === "/profile/settings"
    ) {
      dispatch(rerender());
    }
  };

  return (
    <div className={isMobileMenu ? styles.icons__auth_mobileMenu : styles.icons__auth}>
      <Link
        to={auth ? "/profile" : ""}
        onClick={
          auth ? handleClickProfile : handleClickLogin
        }
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isMobileMenu ? null : (
          <img src={isHovered ? profileIconFocus : profileIcon} alt="profile" width={20} height={20} />           
        )}

        <span>
          {auth ? "Профиль" : "Войти"}
        </span>
      </Link>
      {isOpen ? <LoginModal isOpen={isOpen} setIsOpen={setIsOpen} /> : null}
    </div>
  );
};
